import React from 'react';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { StyledAppItem } from './ApplicationSwitcher.styles.js';
import { strings } from './strings.js';

var ApplicationSwitcherLaunchpadItem = function ApplicationSwitcherLaunchpadItem(_ref) {
  var url = _ref.url,
      numberOfColumns = _ref.numberOfColumns;
  var label = strings.manageAppsAndSettings;
  return React.createElement(React.Fragment, null, numberOfColumns > 1 ? React.createElement("a", {
    href: url
  }, React.createElement(NavbarHelixIcon, {
    iconName: 'app_grid'
  }), React.createElement("span", {
    className: 'helix-navbar__application-switcher-launchpad-item__label'
  }, label)) : React.createElement(StyledAppItem, null, React.createElement("div", {
    className: 'menu-item-content-wrapper'
  }, React.createElement("a", {
    href: url
  }, React.createElement("div", {
    className: 'helix-app-switcher__item-icon'
  }, React.createElement(NavbarHelixIcon, {
    iconName: 'app_grid'
  })), React.createElement("div", {
    className: 'menu-item-content'
  }, React.createElement("span", {
    className: 'helix-navbar__application-switcher-launchpad-item__label'
  }, label))))));
};

ApplicationSwitcherLaunchpadItem.displayName = 'ApplicationSwitcherLaunchpadItem';
export { ApplicationSwitcherLaunchpadItem as default };